module.exports = __webpack_public_path__ + "img/bigmind-logo.20159118.png";